import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { errMsg, errMsgNoData } from '../helper/functions';
import {
  AllReviewsProps,
  createQuarterProps,
  quarterlyUsers,
  updateFeedbacksPayload,
  updateQuarterProps,
  ErrorResponseType,
  QuarterlyUserStatus,
} from '../types';

const getAllQuartersCode = import.meta.env.VITE_GET_ALL_QUARTER;
const createQuarterCode = import.meta.env.VITE_CREATE_QUARTER;
const getQuarterCode = import.meta.env.VITE_GET_QUARTER;
const updateCode = import.meta.env.VITE_UPDATE_QUARTER;
const getQuarterlyUsersCode = import.meta.env.VITE_GET_QUARTERLY_USERS;
const updateFeedbackCode = import.meta.env.VITE_UPDATE_FEEDBACK;
const getQuarterlyUserStatusCode = import.meta.env.VITE_QUARTERLY_USER_STATUS;

export const getAllQuarters = async (mode?: string) => {
  const ret: { data: AllReviewsProps[]; error: ErrorResponseType | null } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.quarters}?code=${getAllQuartersCode}${mode ? `&mode=${mode}` : ''}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const createQuarter = async (payload: createQuarterProps) => {
  const ret: { data: AllReviewsProps[]; error: ErrorResponseType | null } = {
    error: null,
    data: [],
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.quarter}?code=${createQuarterCode}`,
      payload
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getQuarter = async (id: string, mode?: string) => {
  const ret: { data?: AllReviewsProps; error?: ErrorResponseType | null } = {
    error: null,
  };

  try {
    const { data } = await axios.get(
      `${apiPaths.quarters}/${id}?code=${getQuarterCode}${mode ? `&mode=${mode}` : ''}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err: any) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const updateQuarter = async (payload: updateQuarterProps) => {
  const ret: { data: updateQuarterProps[]; error: ErrorResponseType | null } = {
    error: null,
    data: [],
  };
  try {
    const { data } = await axios.put(
      `${apiPaths.quarters}/${payload.id}?code=${updateCode}`,
      payload
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

// get all quarterly users
export const getQuarterlyUsers = async (id: string, mode: string) => {
  const ret: { data?: quarterlyUsers[]; error: ErrorResponseType | null } = {
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.quarterlyUsers}?code=${getQuarterlyUsersCode}&mode=${mode}&quarterId=${id}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

// update feedback
export const updateFeedbacks = async (payload: updateFeedbacksPayload) => {
  const ret: { data: any; error: ErrorResponseType | null } = {
    error: null,
    data: [],
  };
  try {
    const { data } = await axios.put(
      `${apiPaths.updateFeedback}?code=${updateFeedbackCode}`,
      payload
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }

    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

// get quarterly user status
export const getQuarterlyUserStatus = async (id: string, quarterId: string) => {
  const ret: { data?: QuarterlyUserStatus; error: ErrorResponseType | null } = {
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.quarterlyUserStatus}/${id}?&quarterId=${quarterId}&code=${getQuarterlyUserStatusCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};
